export const API_URL = 'https://flicktionary.onrender.com';
